export default __webpack_public_path__ + "static/media/prampe1.aa475e61.jpg";